import { useState } from "react";

interface Community {
  name: string;
  route: string;
}

interface Subregion {
  name: string;
  description: string;
  communities: Community[];
  hub: { name: string; route: string };
}

interface Region {
  id: string;
  name: string;
  icon: string;
  subregions: Subregion[];
}

const regions: Region[] = [
  {
    id: "boston",
    name: "Greater Boston",
    icon: "ri-building-2-line",
    subregions: [
      {
        name: "Boston & Cambridge",
        description: "Back Bay, Beacon Hill, South End, North End, and Cambridge across the Charles River. Logan Airport (BOS) is the major international hub. The Red, Green, and Orange lines connect the metro.",
        hub: { name: "Boston", route: "/cities/boston" },
        communities: [
          { name: "Back Bay", route: "#" }, { name: "Beacon Hill", route: "#" },
          { name: "South End", route: "#" }, { name: "North End", route: "#" },
          { name: "Cambridge", route: "#" }, { name: "Somerville", route: "#" },
          { name: "Brookline", route: "#" }, { name: "Allston", route: "#" },
          { name: "Brighton", route: "#" }, { name: "Charlestown", route: "#" },
          { name: "Dorchester", route: "#" }, { name: "South Boston", route: "#" },
          { name: "East Boston", route: "#" }, { name: "Jamaica Plain", route: "#" },
        ],
      },
      {
        name: "Metro West",
        description: "Newton, Waltham, Watertown, and Needham — west of Boston along the Mass Pike and Route 9. The commuter rail connects to South Station.",
        hub: { name: "Newton", route: "#" },
        communities: [
          { name: "Newton", route: "#" }, { name: "Waltham", route: "#" },
          { name: "Watertown", route: "#" }, { name: "Needham", route: "#" },
          { name: "Natick", route: "#" }, { name: "Framingham", route: "#" },
          { name: "Wellesley", route: "#" }, { name: "Weston", route: "#" },
          { name: "Wayland", route: "#" }, { name: "Sudbury", route: "#" },
          { name: "Lincoln", route: "#" }, { name: "Concord", route: "#" },
          { name: "Lexington", route: "#" }, { name: "Arlington", route: "#" },
        ],
      },
      {
        name: "North Shore",
        description: "Lynn, Salem, Peabody, and Revere along the Atlantic coast. Logan Airport is accessible via Route 1A. The commuter rail serves the North Shore corridor.",
        hub: { name: "Lynn", route: "#" },
        communities: [
          { name: "Lynn", route: "#" }, { name: "Salem", route: "#" },
          { name: "Peabody", route: "#" }, { name: "Revere", route: "#" },
          { name: "Saugus", route: "#" }, { name: "Malden", route: "#" },
          { name: "Melrose", route: "#" }, { name: "Stoneham", route: "#" },
          { name: "Wakefield", route: "#" }, { name: "Reading", route: "#" },
          { name: "Wilmington", route: "#" }, { name: "Beverly", route: "#" },
          { name: "Danvers", route: "#" }, { name: "Gloucester", route: "#" },
        ],
      },
      {
        name: "South Shore",
        description: "Quincy, Braintree, Weymouth, and Milton south of Boston. The Red Line connects Quincy to downtown. Route 3 is the main highway corridor.",
        hub: { name: "Quincy", route: "#" },
        communities: [
          { name: "Quincy", route: "#" }, { name: "Braintree", route: "#" },
          { name: "Weymouth", route: "#" }, { name: "Milton", route: "#" },
          { name: "Hingham", route: "#" }, { name: "Hull", route: "#" },
          { name: "Cohasset", route: "#" }, { name: "Scituate", route: "#" },
          { name: "Norwell", route: "#" }, { name: "Hanover", route: "#" },
          { name: "Rockland", route: "#" }, { name: "Abington", route: "#" },
          { name: "Whitman", route: "#" }, { name: "East Bridgewater", route: "#" },
        ],
      },
    ],
  },
  {
    id: "central",
    name: "Central Massachusetts",
    icon: "ri-landscape-line",
    subregions: [
      {
        name: "Worcester County",
        description: "Worcester, Auburn, Shrewsbury, and the Blackstone Valley. Worcester Regional Airport (ORH) is the local airport. The Mass Pike and Route 9 are the major east-west corridors.",
        hub: { name: "Worcester", route: "/cities/worcester" },
        communities: [
          { name: "Worcester", route: "#" }, { name: "Auburn", route: "#" },
          { name: "Shrewsbury", route: "#" }, { name: "Leominster", route: "#" },
          { name: "Fitchburg", route: "#" }, { name: "Gardner", route: "#" },
          { name: "Westborough", route: "#" }, { name: "Northborough", route: "#" },
          { name: "Grafton", route: "#" }, { name: "Millbury", route: "#" },
          { name: "Sutton", route: "#" }, { name: "Holden", route: "#" },
          { name: "Rutland", route: "#" }, { name: "Spencer", route: "#" },
        ],
      },
      {
        name: "Blackstone Valley",
        description: "Milford, Uxbridge, Blackstone, and the historic mill towns along the Blackstone River. The Route 146 corridor connects to Providence, RI.",
        hub: { name: "Milford", route: "#" },
        communities: [
          { name: "Milford", route: "#" }, { name: "Uxbridge", route: "#" },
          { name: "Blackstone", route: "#" }, { name: "Mendon", route: "#" },
          { name: "Hopedale", route: "#" }, { name: "Bellingham", route: "#" },
          { name: "Franklin", route: "#" }, { name: "Wrentham", route: "#" },
          { name: "Plainville", route: "#" }, { name: "North Attleborough", route: "#" },
          { name: "Attleboro", route: "#" }, { name: "Seekonk", route: "#" },
          { name: "Swansea", route: "#" }, { name: "Somerset", route: "#" },
        ],
      },
    ],
  },
  {
    id: "western",
    name: "Western Massachusetts",
    icon: "ri-landscape-line",
    subregions: [
      {
        name: "Pioneer Valley",
        description: "Springfield, Chicopee, West Springfield, and Holyoke along the Connecticut River. The Mass Pike (I-90) connects to Boston. Bradley International (BDL) in Hartford is the closest major airport.",
        hub: { name: "Springfield", route: "#" },
        communities: [
          { name: "Springfield", route: "#" }, { name: "Chicopee", route: "#" },
          { name: "West Springfield", route: "#" }, { name: "Holyoke", route: "#" },
          { name: "Agawam", route: "#" }, { name: "East Longmeadow", route: "#" },
          { name: "Longmeadow", route: "#" }, { name: "Ludlow", route: "#" },
          { name: "Westfield", route: "#" }, { name: "Southwick", route: "#" },
          { name: "South Hadley", route: "#" }, { name: "Northampton", route: "#" },
          { name: "Easthampton", route: "#" }, { name: "Amherst", route: "#" },
        ],
      },
      {
        name: "Berkshires",
        description: "Pittsfield, North Adams, Great Barrington, and the western mountain region. Tanglewood and MassMoCA are major cultural attractions. The closest major airport is Albany (ALB).",
        hub: { name: "Pittsfield", route: "#" },
        communities: [
          { name: "Pittsfield", route: "#" }, { name: "North Adams", route: "#" },
          { name: "Great Barrington", route: "#" }, { name: "Lenox", route: "#" },
          { name: "Stockbridge", route: "#" }, { name: "Lee", route: "#" },
          { name: "Dalton", route: "#" }, { name: "Lanesborough", route: "#" },
          { name: "Hinsdale", route: "#" }, { name: "Windsor", route: "#" },
          { name: "Becket", route: "#" }, { name: "Otis", route: "#" },
          { name: "Sandisfield", route: "#" }, { name: "Sheffield", route: "#" },
        ],
      },
    ],
  },
  {
    id: "cape",
    name: "Cape & South Coast",
    icon: "ri-sun-line",
    subregions: [
      {
        name: "Cape Cod",
        description: "Hyannis, Barnstable, Falmouth, and Provincetown. The Sagamore and Bourne bridges connect to the mainland. Summer tourism creates seasonal passport demand.",
        hub: { name: "Hyannis", route: "#" },
        communities: [
          { name: "Hyannis", route: "#" }, { name: "Barnstable", route: "#" },
          { name: "Falmouth", route: "#" }, { name: "Provincetown", route: "#" },
          { name: "Chatham", route: "#" }, { name: "Orleans", route: "#" },
          { name: "Eastham", route: "#" }, { name: "Wellfleet", route: "#" },
          { name: "Truro", route: "#" }, { name: "Sandwich", route: "#" },
          { name: "Bourne", route: "#" }, { name: "Mashpee", route: "#" },
          { name: "Yarmouth", route: "#" }, { name: "Dennis", route: "#" },
        ],
      },
      {
        name: "South Coast",
        description: "New Bedford, Fall River, Dartmouth, and Fairhaven. The fishing and maritime heritage makes this a unique community. Direct ferry connections to Martha's Vineyard.",
        hub: { name: "New Bedford", route: "#" },
        communities: [
          { name: "New Bedford", route: "#" }, { name: "Fall River", route: "#" },
          { name: "Dartmouth", route: "#" }, { name: "Fairhaven", route: "#" },
          { name: "Acushnet", route: "#" }, { name: "Westport", route: "#" },
          { name: "Swansea", route: "#" }, { name: "Somerset", route: "#" },
          { name: "Seekonk", route: "#" }, { name: "Rehoboth", route: "#" },
          { name: "Attleboro", route: "#" }, { name: "North Attleborough", route: "#" },
          { name: "Taunton", route: "#" }, { name: "Raynham", route: "#" },
        ],
      },
    ],
  },
  {
    id: "northeast",
    name: "Northeast & Merrimack",
    icon: "ri-ship-line",
    subregions: [
      {
        name: "Merrimack Valley",
        description: "Lowell, Lawrence, Haverhill, and the historic mill cities along the Merrimack River. The commuter rail connects to Boston. Route 495 is the major highway.",
        hub: { name: "Lowell", route: "#" },
        communities: [
          { name: "Lowell", route: "#" }, { name: "Lawrence", route: "#" },
          { name: "Haverhill", route: "#" }, { name: "Methuen", route: "#" },
          { name: "Andover", route: "#" }, { name: "North Andover", route: "#" },
          { name: "Dracut", route: "#" }, { name: "Tewksbury", route: "#" },
          { name: "Billerica", route: "#" }, { name: "Chelmsford", route: "#" },
          { name: "Westford", route: "#" }, { name: "Tyngsborough", route: "#" },
          { name: "Dunstable", route: "#" }, { name: "Groton", route: "#" },
        ],
      },
      {
        name: "Southeastern MA",
        description: "Brockton, Taunton, Plymouth, and the communities along Route 24. The commuter rail connects Brockton to Boston. Cape Cod is accessible via Route 3.",
        hub: { name: "Brockton", route: "#" },
        communities: [
          { name: "Brockton", route: "#" }, { name: "Taunton", route: "#" },
          { name: "Plymouth", route: "#" }, { name: "Bridgewater", route: "#" },
          { name: "Middleborough", route: "#" }, { name: "Lakeville", route: "#" },
          { name: "Rochester", route: "#" }, { name: "Wareham", route: "#" },
          { name: "Marion", route: "#" }, { name: "Mattapoisett", route: "#" },
          { name: "Fairhaven", route: "#" }, { name: "New Bedford", route: "#" },
          { name: "East Bridgewater", route: "#" }, { name: "West Bridgewater", route: "#" },
        ],
      },
    ],
  },
];

export default function MassachusettsCommunitiesWeServe() {
  const [activeRegion, setActiveRegion] = useState(regions[0].id);

  const current = regions.find((r) => r.id === activeRegion) || regions[0];

  return (
    <section id="communities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Statewide Coverage
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Communities We Serve Across Massachusetts
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Don't see your city in the directory above? You're still covered. Every Massachusetts community below is served through our nearest hub — with the same fast, reliable expedited passport processing.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {regions.map((region) => (
            <button
              key={region.id}
              onClick={() => setActiveRegion(region.id)}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                activeRegion === region.id
                  ? "bg-[#1A365D] text-white"
                  : "bg-[#EEF2F8] text-[#1A365D] hover:bg-[#dce5f3]"
              }`}
            >
              <i className={`${region.icon} text-base`}></i>
              {region.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {current.subregions.map((sub, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-100">
              <div className="flex items-start justify-between gap-4 mb-3">
                <h3 className="font-bold text-[#1A365D] text-base">{sub.name}</h3>
                <a
                  href={sub.hub.route}
                  className="flex-shrink-0 inline-flex items-center gap-1 bg-[#1A365D] text-white text-xs font-semibold px-3 py-1.5 rounded-full hover:bg-[#F6C344] hover:text-[#1A365D] transition-all whitespace-nowrap"
                >
                  Hub: {sub.hub.name} <i className="ri-arrow-right-line"></i>
                </a>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{sub.description}</p>
              <div className="flex flex-wrap gap-2">
                {sub.communities.map((c, j) => (
                  <a
                    key={j}
                    href={c.route}
                    className="inline-flex items-center text-xs font-medium text-[#1A365D] bg-white border border-gray-200 rounded-full px-3 py-1 hover:border-[#F6C344] hover:text-[#1A365D] transition-all whitespace-nowrap cursor-pointer"
                  >
                    {c.name}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-400 text-sm mt-8">
          Not finding your exact community? <a href="tel:8772530084" className="text-[#1A365D] font-semibold hover:text-[#F6C344] transition-colors">Call us at 877-253-0084</a> — we serve all of Massachusetts.
        </p>
      </div>
    </section>
  );
}